// PRD 121 — personal services ships dark until milestone M1 is reachable
// (scope §8: PRDs 121–126 and 128 Wave 1). While false, the sidebar's
// Appointments group draws only for a business holding the module — design
// partners on an admin grant — and BusinessContext asks no other business
// about it.
//
// A web merge deploys to production, so this constant — not the api's
// `released: false` alone — is what keeps the pages and the nav group from
// every business without the grant. It flips in the same pair of PRs as the
// api's catalogue `released: true` and the Marketplace card's move from
// "coming soon" to a module card (PRD 121 §4.12, "Release").
export const PERSONAL_SERVICES_RELEASED = false;
